export default __webpack_public_path__ + "static/media/Equi-facile.dc0c63e6.png";